import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'duration',
  standalone: false,
})
export class DurationPipe implements PipeTransform {
  transform(durationSec?: number): number {
    const durationHrs = durationSec ? durationSec / 3600 : null
    return durationHrs
  }
}
